import { Component, Input } from "@angular/core";
import { SearchComponent } from "../search-component";

@Component({
  selector: 'search-paging',
  templateUrl: './search-paging.component.html',
  styleUrls: ['./search-paging.component.css'],
})
export class SearchPagingComponent {
  @Input()
  public loading!: boolean;

  @Input()
  searchComponent!: SearchComponent<any>;
}